import { Wifi, Phone, Server, Shield, Network } from 'lucide-react';
import { Service } from '../types';

export const businessServices: Service[] = [
  {
    icon: <Wifi className="h-12 w-12" />,
    title: "Internet Business",
    description: "Soluții de internet dedicate pentru afaceri, cu SLA garantat și suport prioritar",
    features: [
      "Conexiune simetrică prin fibră optică",
      "Bandă garantată prin SLA",
      "IP-uri statice incluse",
      "Monitorizare 24/7",
      "Suport tehnic prioritar"
    ],
    packages: [
      {
        name: "Business Start",
        price: "300",
        features: [
          "Până la 70 Mbps",
          "1 IP Static",
          "SLA Standard",
          "Suport 24/7"
        ]
      },
      {
        name: "Business Pro",
        price: "450",
        features: [
          "Până la 100 Mbps",
          "5 IP-uri Statice",
          "SLA Premium",
          "Suport Prioritar"
        ]
      },
      {
        name: "Enterprise",
        price: "1800",
        features: [
          "Până la 1 Gbps",
          "Subnet /29",
          "SLA Enterprise",
          "Manager Dedicat"
        ]
      }
    ]
  },
  {
    icon: <Server className="h-12 w-12" />,
    title: "Hosting & Cloud",
    description: "Servicii de hosting și cloud pentru aplicațiile și datele companiei tale",
    features: [
      "Servere dedicate și VPS-uri performante",
      "Backup automat și redundanță",
      "Securitate avansată",
      "Scalabilitate instantanee",
      "Panel de administrare intuitiv"
    ],
    packages: [
      {
        name: "Cloud Start",
        price: "299",
        features: [
          "2 vCPU",
          "4GB RAM",
          "100GB SSD",
          "1TB Transfer"
        ]
      },
      {
        name: "Cloud Pro",
        price: "599",
        features: [
          "4 vCPU",
          "8GB RAM",
          "200GB SSD",
          "2TB Transfer"
        ]
      },
      {
        name: "Cloud Enterprise",
        price: "1299",
        features: [
          "8 vCPU",
          "16GB RAM",
          "500GB SSD",
          "5TB Transfer"
        ]
      }
    ]
  },
  {
    icon: <Network className="h-12 w-12" />,
    title: "Rețele Private",
    description: "Soluții complete de rețele private și VPN pentru conectarea sigură a locațiilor",
    features: [
      "Configurare personalizată pentru nevoile companiei",
      "Criptare end-to-end",
      "QoS pentru aplicații critice",
      "Monitorizare și raportare",
      "Suport tehnic dedicat"
    ],
    packages: [
      {
        name: "VPN Basic",
        price: "399",
        features: [
          "Până la 5 locații",
          "100 Mbps/locație",
          "Configurare de bază",
          "Suport 8/5"
        ]
      },
      {
        name: "VPN Advanced",
        price: "799",
        features: [
          "Până la 10 locații",
          "500 Mbps/locație",
          "QoS avansat",
          "Suport 24/7"
        ]
      }
    ]
  },
  {
    icon: <Shield className="h-12 w-12" />,
    title: "Securitate",
    description: "Protecție completă pentru infrastructura IT a companiei tale",
    features: [
      "Firewall de nouă generație",
      "Protecție DDoS",
      "Filtrare conținut",
      "VPN SSL și IPSec",
      "Monitorizare și alertare"
    ],
    packages: [
      {
        name: "Security Basic",
        price: "499",
        features: [
          "Firewall de bază",
          "Anti-malware",
          "VPN de bază",
          "Suport 8/5"
        ]
      },
      {
        name: "Security Pro",
        price: "999",
        features: [
          "NGFW",
          "DDoS Protection",
          "VPN Avansat",
          "Suport 24/7"
        ]
      },
      {
        name: "Security Enterprise",
        price: "1999",
        features: [
          "NGFW Enterprise",
          "DDoS Advanced",
          "SOC as a Service",
          "Manager Dedicat"
        ]
      }
    ]
  }
];